import { z } from 'zod';

export const depositCurrenciesSchema = z.object({
  currencies: z.array(z.string().min(1)),
});

const destination = z.object({ currency: z.string().min(1), tag: z.string().min(1).nullable() });

export const depositAddressSchema = z.discriminatedUnion('state', [
  destination.extend({ state: z.literal('ready'), address: z.string().min(1) }),
  destination.extend({ state: z.enum(['new', 'unknown']), address: z.string().nullable() }),
]);

export type ZeroXAddress = z.infer<typeof depositAddressSchema>;

// Proposed SPOR-4556 player contract. Amounts remain strings throughout the UI.
const positiveDecimal = z
  .string()
  .regex(/^(0|[1-9]\d*)(\.\d+)?$/)
  .refine((value) => /[1-9]/.test(value));

export const depositMinimumSchema = z
  .object({
    currency: z.string().min(1),
    effectiveMinimum: positiveDecimal.nullable(),
    isEstimate: z.boolean(),
    asOf: z.iso.datetime({ offset: true }).nullable(),
  })
  .refine((value) => value.effectiveMinimum === null || value.asOf !== null, {
    message: 'Available minimum metadata requires a timestamp',
    path: ['asOf'],
  });

export type ZeroXDepositMinimum = z.infer<typeof depositMinimumSchema>;
export type ZeroXDepositMinimumState =
  | { status: 'idle' }
  | { status: 'loading' }
  | { status: 'unavailable' }
  | { status: 'available'; data: ZeroXDepositMinimum & { effectiveMinimum: string; asOf: string } };
